"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAggregatedProductMeasureUnits = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const ramda_1 = require("ramda");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const hooks_1 = require("../../hooks");
const constants_1 = require("../constants");
const gql_1 = require("../gql");
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b;
    const { edges: prevMeasures = [] } = (_a = previousResult.productTreeNode.productAggregatedMeasures) !== null && _a !== void 0 ? _a : {};
    const { productTreeNode } = (_b = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _b !== void 0 ? _b : {};
    const _c = productTreeNode.productAggregatedMeasures, { edges = [] } = _c, productAggregateLabels = __rest(_c, ["edges"]);
    if (!edges.length) {
        return {
            productTreeNode: Object.assign(Object.assign({}, previousResult.productTreeNode), productTreeNode),
        };
    }
    const newMeasure = edges[0].node;
    const changedMeasureIndex = prevMeasures.findIndex(({ node }) => node.dimension === newMeasure.dimension);
    const prevAttribute = prevMeasures[changedMeasureIndex];
    const changedMeasure = {
        node: Object.assign(Object.assign({}, prevAttribute.node), { units: Object.assign(Object.assign({}, newMeasure.units), { edges: [...prevAttribute.node.units.edges, ...newMeasure.units.edges] }) }),
    };
    const newAttributes = (0, ramda_1.update)(changedMeasureIndex, changedMeasure, prevMeasures);
    return {
        productTreeNode: Object.assign(Object.assign({}, productTreeNode), { productAggregateLabels: Object.assign(Object.assign({}, productAggregateLabels), { edges: newAttributes }) }),
    };
};
const fetchMoreOptions = { updateQuery };
const useGetAggregatedProductMeasureUnits = ({ catalogId, productTreeNodeId, dimension, sortingItem, options, }) => {
    var _a, _b, _c;
    const sort = constants_1.sortingItemToAggregatedProductMeasureUnitsSortMap[sortingItem];
    const [getAggregatedProductMeasureUnits, { data, error, networkStatus, variables, fetchMore, }] = (0, react_2.useLazyQuery)(gql_1.GET_AGGREGATED_PRODUCT_MEASURE_UNITS, {
        notifyOnNetworkStatusChange: true,
    });
    // using useQuery skip: true will remove all previously uploaded data
    (0, react_1.useEffect)(() => {
        if (dimension && !(options === null || options === void 0 ? void 0 : options.skip)) {
            void getAggregatedProductMeasureUnits({
                variables: {
                    sort,
                    dimension,
                    productTreeNodeId: productTreeNodeId !== null && productTreeNodeId !== void 0 ? productTreeNodeId : '',
                    catalog: catalogId,
                    first: client_constants_1.PAGE_SIZE_LARGE,
                    last: null,
                    before: null,
                    after: null,
                },
            });
        }
    }, [catalogId, dimension, getAggregatedProductMeasureUnits, options === null || options === void 0 ? void 0 : options.skip, productTreeNodeId, sort]);
    const { units } = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.productAggregatedMeasures.edges[0]) === null || _b === void 0 ? void 0 : _b.node) !== null && _c !== void 0 ? _c : {};
    const { edges, pageInfo } = units !== null && units !== void 0 ? units : {};
    const pagination = (0, hooks_1.usePagination)({
        pageInfo,
        networkStatus,
        pageSize: client_constants_1.PAGE_SIZE_LARGE,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    return {
        data: edges,
        pagination,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        isRefetching: (0, client_utils_1.isQueryRefetching)(networkStatus),
        error,
    };
};
exports.useGetAggregatedProductMeasureUnits = useGetAggregatedProductMeasureUnits;
